/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-09-16 16:51:44
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @LastEditTime: 2022-09-20 13:50:30
 * @FilePath: /pscd-portal-www/packages/clients/apis/codetable.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { IAjaxConfig } from '../helpers';
export class EnumApiCodetable {
  /**
   * @dec 获取码表
   * @method get
   * @params
   */
  readonly codetable_get: IAjaxConfig = {
    url: '/api/gateway/code-table/dictionary-item/{dicType}/dictionary-type',
    method: 'get',
  };

  /**
   * @dec 经销商类型列表
   * @method get
   * @params
   */
  readonly bpresellertypeinfos_get: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/resellerType/listAll',
    method: 'get',
  };

  /**
   * @dec 经销商类型子类型列表
   * @method post
   * @params
   */
  readonly bpresellertypeinfos_findAll: IAjaxConfig = {
    url: '/api/gateway/partner-bff/api/resellerType/listByParams',
    method: 'post',
  };

  /**
   * @dec 批量获取码表
   * @method post
   * @params
   */
  readonly codetable_batch_type: IAjaxConfig = {
    url: '/api/gateway/code-table/dictionary-item/dictionary-type',
    method: 'post',
  };
}
